import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useParams, useNavigate } from "react-router-dom";
import { getProducts } from "../api";

const TON_STEP = 0.02;
const MAX_TON = 2;
const tonOptions = Array.from(
  { length: MAX_TON / TON_STEP },
  (_, i) => Number(((i + 1) * TON_STEP).toFixed(2))
);

const discounted = (price, discount) =>
  discount ? Math.round(price - (price * discount) / 100) : price;

const ProductCard = ({ p }) => {
  const [qtyTon, setQtyTon] = useState("");
  const navigate = useNavigate();

  const addToCart = () => {
    if (!qtyTon || Number(qtyTon) < TON_STEP) {
      toast.error("Minimum 0.02 ton required");
      return;
    }

    const qtyKg = Number(qtyTon) * 1000;
    const user = JSON.parse(localStorage.getItem("user"));
    const cartKey = user ? `cart_${user._id}` : "guest_cart";
    const cart = JSON.parse(localStorage.getItem(cartKey)) || [];

    cart.push({
      cartItemId: Date.now() + Math.random(),
      productId: p._id,
      name: p.name,
      price: discounted(p.price, p.discount),
      quantity: qtyKg,
      unit: "kg",
    });

    localStorage.setItem(cartKey, JSON.stringify(cart));
    toast.success(`${p.name} added to cart`);
    setQtyTon("");
  };

  const buyNow = () => {
    if (!qtyTon || Number(qtyTon) < TON_STEP) {
      toast.error("Minimum 0.02 ton required");
      return;
    }

    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) {
      toast.error("Please login first");
      navigate("/login");
      return;
    }

    const cartKey = `cart_${user._id}`;
    const cart = [{
      cartItemId: Date.now(),
      productId: p._id,
      name: p.name,
      price: discounted(p.price, p.discount),
      quantity: Number(qtyTon) * 1000,
      unit: "kg",
    }];

    localStorage.setItem(cartKey, JSON.stringify(cart));
    navigate("/cart");
  };

  return (
    <div className="col">
      <div className="card h-100 border-0 shadow-sm rounded-4 position-relative">
        {p.discount > 0 && (
          <span className="badge bg-danger position-absolute top-0 start-0 m-3 rounded-pill">
            {p.discount}% OFF
          </span>
        )}

        <img
          src={p.image}
          alt={p.name}
          className="card-img-top rounded-top-4"
          style={{ height: "220px", objectFit: "cover" }}
        />

        <div className="card-body d-flex flex-column">
          <h6 className="fw-semibold">{p.name}</h6>

          {p.discount ? (
            <div className="mb-2">
              <span className="text-muted text-decoration-line-through me-2">
                ₹{p.price}
              </span>
              <span className="fw-bold text-success">
                ₹{discounted(p.price, p.discount)} / kg
              </span>
            </div>
          ) : (
            <p className="fw-bold text-success">₹{p.price} / kg</p>
          )}

          <select
            className="form-select form-select-sm mb-2"
            value={qtyTon}
            onChange={(e) => setQtyTon(e.target.value)}
          >
            <option value="">Select Quantity (tons)</option>
            {tonOptions.map((ton) => (
              <option key={ton} value={ton}>
                {ton} ton
              </option>
            ))}
          </select>

          <div className="d-grid gap-2 mt-auto">
            <button className="btn btn-outline-primary btn-sm" onClick={addToCart}>
              🛒 Add to Cart
            </button>
            <button className="btn btn-success btn-sm" onClick={buyNow}>
              ⚡ Buy Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const Products = () => {
  const { category } = useParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    getProducts()
      .then((data) => setProducts(data))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  const list = category
    ? products.filter((p) => p.category === category)
    : products;

  if (loading) return <p className="text-center mt-5">Loading products...</p>;
  if (error) return <p className="text-center text-danger mt-5">{error}</p>;

  return (
    <div className="container-fluid py-4 px-4">
      {/* ✅ Toaster sirf ek baar yahan */}
      <Toaster />

      <h2 className="text-center mb-4 fw-bold">
        {category ? category.toUpperCase() : "ALL"} PRODUCTS
      </h2>

      <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4">
        {list.map((p) => (
          <ProductCard key={p._id} p={p} />
        ))}

        {list.length === 0 && (
          <p className="text-center text-muted">No products found</p>
        )}
      </div>
    </div>
  );
};

export default Products;